import { Flex, Form, Input, Select } from 'antd';
import dayjs from 'dayjs';
import { t } from 'i18next';

import {
  useReportActivityAnalyzeFilters,
  useReportActivityAnalyzeFiltersFormName,
} from 'business/shift-report/report-analyze/pages/activity-analyze/providers/filters';
import {
  ACTIVITY_DISPLAY_TYPES,
  ACTIVITY_DISPLAY_TYPES_MAP,
  ACTIVITY_GROUP_BY_TYPES,
  ACTIVITY_GROUP_BY_TYPES_MAP,
} from 'business/shift-report/report-analyze/pages/activity-analyze/types';
import { PreselectTemporalSelectInput } from 'ui/form/preselect-date-select-input';

export const MobileActivityAnalyzeFilters = () => {
  const formName = useReportActivityAnalyzeFiltersFormName();
  const [form] = Form.useForm();

  const filters = useReportActivityAnalyzeFilters();

  return (
    <Flex wrap gap={8}>
      <Form layout="inline" form={form} name={formName} initialValues={filters}>
        <Form.Item name="filterType" hidden>
          <Input disabled />
        </Form.Item>
        <Form.Item
          name="dateRange"
          label={t('input.dateRange.label')}
          layout="horizontal"
        >
          <PreselectTemporalSelectInput mode="date" defaultDate={dayjs()} />
        </Form.Item>

        <Form.Item
          name="groupByType"
          label={t('reportAnalyze.activityAnalyze.input.groupByOptions')}
          style={{ minWidth: '110px' }}
          layout="horizontal"
        >
          <Select
            popupMatchSelectWidth={false}
            options={ACTIVITY_GROUP_BY_TYPES.filter(
              (key) => key !== ACTIVITY_GROUP_BY_TYPES_MAP.activity,
            ).map((value) => ({
              label: t(`reportAnalyze.activityAnalyze.input.groupByOptions`, {
                context: value,
              }),
              value,
            }))}
          />
        </Form.Item>

        <Form.Item
          name="displayType"
          label={t('reportAnalyze.activityAnalyze.input.displayTypeOptions')}
          layout="horizontal"
        >
          <Select
            popupMatchSelectWidth={false}
            options={ACTIVITY_DISPLAY_TYPES.filter(
              (key) => key !== ACTIVITY_DISPLAY_TYPES_MAP.table,
            ).map((value) => ({
              label: t(
                `reportAnalyze.activityAnalyze.input.displayTypeOptions`,
                {
                  context: value,
                },
              ),
              value,
            }))}
          />
        </Form.Item>
      </Form>
    </Flex>
  );
};
